import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { TagModule } from 'primeng/tag';

/**
 * ──────────────────────────────────────────────────────────────
 *  WSKAZÓWKA POZYCJONOWANIA W KROKU KREATORA (dumb)
 * ──────────────────────────────────────────────────────────────
 *
 *  Lekki callout u góry kroku, tłumaczący DLACZEGO uzupełnienie tej
 *  sekcji podnosi BEZPŁATNĄ widoczność obiektu. `text` przekazuje rodzic
 *  (już przetłumaczony przez transloco), badge "Bezpłatne" jest tu.
 */
@Component({
  selector: 'app-wizard-step-hint',
  standalone: true,
  imports: [TranslocoModule, TagModule],
  templateUrl: './wizard-step-hint.component.html',
  styleUrl: './wizard-step-hint.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WizardStepHintComponent {
  /** Tekst wskazówki — przekazany już przetłumaczony przez rodzica. */
  readonly text = input.required<string>();
  /** Ikona PrimeIcons. */
  readonly icon = input<string>('pi pi-bolt');
}
